export const getYears = (initialYear: number, count: number = 10): number[] => {
    const years = []

    for (let i = 0; i <= count; i++) {
        years.push(initialYear - i)
    }

    return years
}

export const getCurrentYear = () => new Date().getFullYear()

export const getSortingSteps = () => {
    return [10, 25, 50, 100]
}